//Componentes generales
import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import DistribucionList from "../../components/DistribucionList/DistribucionList";

//Context
import distribucionesContext from "../../context/distribuciones/distribucionesContext";
import authContext from "../../context/authentication/authContex";

// Alertas
import Swal from "sweetalert2";

//Estilos
import "./Distribucion.css";

//Iconos
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

/*
    Vista donde se gestiona toda la lógica de listado de distribuciones.
    Donde props no se encuentra en uso.
*/
function Distribucion(props) {
  //Context Auth
  const aContext = useContext(authContext);
  const { usuario } = aContext;

  //Context distribuciones
  const dContext = useContext(distribucionesContext);
  const { distribuciones, isCargando, actualizarDistribuciones, actualizarDistribucionesDB } =
    dContext;

  const navigate = useNavigate();

  /*
        Disparador que se ejecuta ante la renderización del componente. El mismo se encarga de actualizar las distribuciones disponibles del context.
    */
  useEffect(() => {
    const fn = async () => {
      await actualizarDistribuciones();
    };
    fn();

  }, []);

  const handleBack = () => {
    navigate("/abms");
  };

  /*
        Manejador que se encarga de la actualización de distribuciones que sobreescribe las distribuciones actuales por las recuperadas de Softland.
    */
  const handlerActualizarDistribuciones = async () => {
    Swal.fire({
      title: "Desea actualizar la lista de distribuciones?",
      text: "Se traeran los datos de Softland para sobreescribir la base de datos de la aplicación.",
      showCancelButton: true,
      confirmButtonText: "Actualizar",
      cancelButtonText: "No, cancelar",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        return await actualizarDistribucionesDB(usuario._id, usuario.userName)
          .then((response) => {
            if (!response.status) {
              throw new Error(response.msg);
            }
            return response;
          })
          .catch((error) => {
            Swal.showValidationMessage(`Request failed: ${error}`);
          });
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire(
          "Actualizado!",
          "La base de datos ha sido actualizada correctamente.",
          "success"
        );
      }
    });
  };

  return (
    <div className="container-list">
      <div className="back-button-container">
        <button className="back-btn" onClick={handleBack}>
          <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: "5px" }} />
        </button>
      </div>
      <div className="actualiza-distribuciones-container">
        <button
          className="actualizar-distribuciones-btn"
          onClick={handlerActualizarDistribuciones}
        >
          Actualizar Distribuciones
        </button>
      </div>
      <DistribucionList distribuciones={distribuciones} cargando={isCargando} />
    </div>
  );
}

export default Distribucion;
